import { useQuery } from "@tanstack/react-query";
import { ParcelService } from "$services";
import { PackageType } from "$types";

export const usePackageTypesQuery = () => {
  return useQuery<PackageType[]>({
    queryKey: ["getPackageTypes"],
    queryFn: () => ParcelService.getPackageTypes(),

    // Package types change rarely
    staleTime: 60 * 60 * 1000,
  });
};
